'use strict';

var _classCallCheck = require("C:\\Users\\gssak\\Desktop\\block-image\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\gssak\\Desktop\\block-image\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\gssak\\Desktop\\block-image\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\gssak\\Desktop\\block-image\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\gssak\\Desktop\\block-image\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _require = require('readable-stream'),
    Readable = _require.Readable;

var _require2 = require('../supports'),
    supportsFileReader = _require2.supportsFileReader;

var streamFromFileReader = function streamFromFileReader(file, options) {
  if (!supportsFileReader) {
    throw new Error('FileReader DOM API is not supported.');
  }

  var FileStream =
  /*#__PURE__*/
  function (_Readable) {
    _inherits(FileStream, _Readable);

    function FileStream(file) {
      var _this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, FileStream);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(FileStream).call(this, options));
      _this.file = file;
      _this.offset = options.offset || 0;
      _this.chunkSize = options.chunkSize || 1024 * 1024;
      _this.fileReader = new self.FileReader(file);

      _this.fileReader.onloadend = function (event) {
        var data = event.target.result;

        if (data.byteLength === 0) {
          _this.push(null);
        }

        _this.push(new Uint8Array(data));
      };

      _this.fileReader.onerror = function (err) {
        return _this.destroy(err);
      };

      return _this;
    }

    _createClass(FileStream, [{
      key: "_read",
      value: function _read(size) {
        var end = this.offset + this.chunkSize;
        var slice = file.slice(this.offset, end);
        this.fileReader.readAsArrayBuffer(slice);
        this.offset = end;
      }
    }]);

    return FileStream;
  }(Readable);

  return new FileStream(file, options);
};

module.exports = streamFromFileReader;